import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { ReactComponent as DownloadIcon } from '@bo-assets/icon/common/icon__download_file.svg';

const ManualDownloadCard = ({ label, onClick }) => {
  return (
    <Card onClick={onClick}>
      <FlexBoxColumn align-items={'flex-start'}>
        <TextBox font-size={20} font-weight={'700'} color={'#333'}>
          {label}
        </TextBox>
      </FlexBoxColumn>
      <DownloadIcon />
    </Card>
  );
};

export default ManualDownloadCard;

ManualDownloadCard.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
};

const Card = styled(FlexBox)`
  height: 90px;
  justify-content: space-between;
  padding: 0 20px;
  border-radius: 6px;
  border: solid 1px #e5e9fd;
  margin-bottom: 12px;

  &:hover {
    cursor: pointer;
  }
`;
